module.exports = __webpack_public_path__ + "img/sensor-red.c0a275dd.svg";